// 현장 셀렉박스 '☑ 내 현장만' · 담당/관리 표시 · 이름 검색 (2026-10-12 개선사항 D-8 · D-10 · D-11)
import type { AssignedMember } from '@indipia/shared-features';

interface AssigneeFields {
  siteName?: string | null;
  customerName?: string | null;
  chargeMembers?: AssignedMember[] | null;
  managerMembers?: AssignedMember[] | null;
  mine?: boolean;
}

/** 검색칸: 현장명 · 고객명 · 담당자·관리자 이름 */
export function matchesSiteQuery(o: AssigneeFields, q: string): boolean {
  const query = q.trim();
  if (!query) return true;
  if ((o.siteName ?? '').includes(query) || (o.customerName ?? '').includes(query)) return true;
  return [...(o.chargeMembers ?? []), ...(o.managerMembers ?? [])]
    .some((m) => (m.memberName ?? '').includes(query));
}

/**
 * '☑ 내 현장만' 적용 + 내 현장 먼저(그 안에서는 기존 순서 유지 — 한 줄 목록, 그룹 없음).
 * 체크를 풀면 모든 현장을 고를 수 있다(권한 제한 없음).
 */
export function applyMineOnly<T extends AssigneeFields>(list: T[], mineOnly: boolean): T[] {
  if (mineOnly) return list.filter((o) => o.mine);
  return [...list.filter((o) => o.mine), ...list.filter((o) => !o.mine)];
}
